import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React from "react";
import Heading from "../components/heading";
import AboutLeft from "../assets/about-left.png";
import AboutRight from "../assets/about-right.png";
import AboutCenter from "../assets/about-center.png";
import { AllImage } from "../styling/style";
import styled from "@emotion/styled";
import AboutImg from "../assets/about-img.png";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const AboutGrid = styled(Grid)`
  padding: 5% 0px;
  @media (max-width: 600px) {
    text-align: center;
  }
`;
const ButtonAbout = styled(Button)`
  text-transform: none;
  background-color: transparent;
  border-radius: 10px;
  color: #ffffff;
  border: 1px solid #ffffff;
  margin-top: 20px;
  padding: 5px 40px;
  font-family: poppins-semibold;
  font-size: 18px;
`;
const ImageGrid = styled(Grid)`
  position: relative;
  overflow: hidden;
  @media (max-width: 900px) {
    justify-content: center;
  }
  @media (max-width: 900px) {
    display: flex;
    justify-content: center;
  }
  @media (min-width: 900px) and (max-width: 1090px) {
    display: flex;
    justify-content: flex-end;
  }
`;
const AboutImgR = styled(AllImage)`
  position: absolute;
  left: 14%;
  top: 9%;
  z-index: 2;
  .animate-right {
    animation: bounce 2s linear infinite;
  }

  @keyframes animate-right {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }
  @media (max-width: 1090px) {
    display: none;
  }
  @media (min-width: 1090px) and (max-width: 1500px) {
    left: 14%;
    top: 12%;
    @keyframes FromLeft {
      0% {
        left: -100%;
        opacity: 0;
      }
      100% {
        left: 5%;
        opacity: 1;
      }
    }
  }
`;
const AboutImgL = styled(AllImage)`
  position: absolute;
  right: -30%;
  top: 75%;
  z-index: 2;
  animation: FromRight 2s forwards, continuousMove 2s linear infinite;
  opacity: 0;

  @keyframes FromRight {
    0% {
      /* right: -100%;  */
      opacity: 0;
    }
    100% {
      right: 0%;
      opacity: 1;
    }
  }
  @media (max-width: 1090px) {
    display: none;
  }
  @media (min-width: 1090px) and (max-width: 1500px) {
    right: -100%;
    top: 80%;
    @keyframes FromRight {
      0% {
        right: -100%;
        opacity: 0;
      }
      100% {
        right: 0%;
        opacity: 1;
      }
    }
  }
`;
const SmaalAboutImg = styled(AllImage)`
  display: none;
  @media (max-width: 1090px) {
    display: block;
  }
  @media (max-width: 900px) {
    max-width: 400px;
  }
  @media (min-width: 900px) and (max-width: 1090px) {
    max-width: 420px;
  }
`;
const AboutImgC = styled(AllImage)`
  position: absolute;
  max-width: 500px;
  left: 22%;
  top: -18%;
  z-index: 1;
  animation: continuousMove 2s linear infinite;

  @keyframes continuousMove {
    0%,
    100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(-5px);
    }
  }
  @media (max-width: 1090px) {
    display: none;
  }
  @media (min-width: 1090px) and (max-width: 1500px) {
    left: 8%;
    top: -10%;
  }
`;
const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      offset: 200,
    });
  }, []);

  useEffect(() => {
    AOS.refresh();
  });
  return (
    <Container maxWidth="lg" id="about">
      <Grid container>
        <Heading title="About" ta="left" tas="center" />
        <AboutGrid
          xs={12}
          md={6}
          data-aos="fade-up"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine"
        >
          <Box sx={{ padding: "20px 0px" }}>
            <Typography
              color="white"
              fontFamily="poppins-regular"
              fontSize="15px"
            >
              At Peachy Trader, we're more than just a platform – we're a
              dynamic community committed to innovation in the ever-evolving
              world of cryptocurrency
            </Typography>
          </Box>
          <Typography
            color="white"
            fontFamily="poppins-regular"
            fontSize="15px"
          >
            Our mission is to empower users with a cutting-edge tool and timely 
information, fostering a more informed and engaged community within 
the crypto landscape.
          </Typography>
          <ButtonAbout data-aos="fade-in" data-aos-duration="1500">
            Read more
          </ButtonAbout>
        </AboutGrid>
        <ImageGrid xs={12} md={6} p={1}>
          <AboutImgL
            maxw="300px"
            src={AboutRight}
            data-aos="slide-left"
            data-aos-duration="1000"
            data-aos-offset="-100"
            className="animate-right"
          />
          <AboutImgC maxw="200px" src={AboutCenter} />
          <AboutImgR
            maxw="300px"
            src={AboutLeft}
            data-aos="fade-right"
            data-aos-offset="300"
          />
          <SmaalAboutImg
            maxw="300px"
            src={AboutImg}
            data-aos="fade-down"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          />
        </ImageGrid>
      </Grid>
    </Container>
  );
};

export default About;
